import { AccordionButton, AccordionItem, AccordionPanel, Button, Flex, Image, Link, Text } from "@chakra-ui/react";
import React from "react";
import { SnippetDisplay } from "./SnippetDisplay";
export const QuestionDisplay = (props) => (React.createElement(AccordionItem, { py: "4", border: "none" },
    React.createElement(AccordionButton, { gap: 4, backgroundColor: "gray.50", borderRadius: "md", p: 6 },
        React.createElement(Text, { as: "h2", fontWeight: "semibold", textStyle: "2xl", color: "brand.500", textAlign: "left" }, props.question.question)),
    React.createElement(AccordionPanel, null,
        React.createElement(Flex, { flexDirection: "column", alignItems: "stretch", gap: 8 }, props.question.content.map((content, index) => {
            if (content.type === "text" && content.text !== null) {
                return (React.createElement("div", { key: index, className: "raw-html", dangerouslySetInnerHTML: { __html: content.text } }));
            }
            if (content.type === "image" && content.thumbnailWebLarge !== null) {
                return (React.createElement(Image, { key: index, src: content.thumbnailWebLarge, maxWidth: "500px" }));
            }
            if (content.type === "callToAction" && content.href !== null) {
                return (React.createElement(Button, { key: index, as: Link, href: content.href, _before: { content: "none" } }, content.text));
            }
            if (content.type === "snippet" && content.id !== null) {
                return (React.createElement(SnippetDisplay, { key: index, snippetId: content.id }));
            }
            return null;
        })))));
